// 开发山东卫视答题需求时的一些复用逻辑

import { getUserRankInfo, getAnserCount } from '@/api/sdws.js'
import { useRoute } from 'vue-router'
import { reactive, watch } from 'vue'
import { useStore } from 'vuex'

// 获得排名信息
export const useCommonUserRankInfoEffect = () => {
  const user = reactive({
    nickName: '',
    headImg: '',
    longTime: 0,
    rightCount: 0,
    rowNum: 0,
    completeTime: 0
  })
  const route = useRoute()

  const fetchUserRankInfo = async userRankInfo => {
    const res = await getUserRankInfo({
      questionActiveKey: route.query.questionActiveKey
    })

    if (res.ok) {
      Object.keys(user).forEach(key => {
        if (res.data) {
          user[key] = res.data[key]
        }
      })
    }
  }

  fetchUserRankInfo()

  return {
    user
  }
}

// 获得答题次数
export const useCommonAnswerCountEffect = () => {
  const route = useRoute()
  const store = useStore()
  const countInfo = reactive({
    count: 0,
    answerFlag: false
  })

  const fetchCountData = async () => {
    if (store.getters.getToken === null) {
      return
    }
    const res = await getAnserCount({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken
    })
    if (res.ok) {
      store.commit('setAnswerCount', {
        data: res.data
      })
    }
  }

  watch(
    () => store.getters.getToken,
    () => {
      fetchCountData()
    }
  )

  fetchCountData()

  return {
    countInfo,
    fetchCountData
  }
}
